import { render, staticRenderFns } from "./LibPricing.vue?vue&type=template&id=5e898ff2&scoped=true&"
import script from "./LibPricing.vue?vue&type=script&lang=js&"
export * from "./LibPricing.vue?vue&type=script&lang=js&"
import style0 from "./LibPricing.vue?vue&type=style&index=0&id=5e898ff2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e898ff2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/gadzoom/gadzoom-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e898ff2')) {
      api.createRecord('5e898ff2', component.options)
    } else {
      api.reload('5e898ff2', component.options)
    }
    module.hot.accept("./LibPricing.vue?vue&type=template&id=5e898ff2&scoped=true&", function () {
      api.rerender('5e898ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pricing/LibPricing.vue"
export default component.exports